var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOxt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5F45BA;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.7,72.9c-3.7,6.2-11.6,8.2-17.8,4.5c-6.2-3.7-8.2-11.6-4.5-17.8s11.6-8.2,17.8-4.5l0,0 C112.3,58.7,114.3,66.7,110.7,72.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3,67.1c-2.6,4.4-8.2,5.8-12.6,3.2c-4.4-2.6-5.8-8.2-3.2-12.6c2.6-4.4,8.2-5.8,12.6-3.2l0,0 C67.4,57.1,68.9,62.8,66.3,67.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.8,255.4c47.7-5.6,86-44.6,89.1-94.1c3.5-55.8-38.9-103.9-94.7-107.4c-6.5-0.4-13.1-0.2-19.6,0.7 c-13.4,1.1-24.7,6.2-24.7,6.2c-9.2,4.5-15.1,12-15.1,22c0,13,10.6,23.6,23.6,23.6c2.2,0,9.7-2.4,11.5-3c6.9-2.4,14.1-3.4,21.4-2.9 c19.3,1.2,35.6,12.3,44.3,28c5.1,9.1,7.4,19.5,6.7,29.9c-1.9,30.1-27.8,52.9-57.9,51c-17.8-1.1-33-10.6-42.1-24.4v0v0 c-10.9-14.3-8.4-37.1-8.4-37.3c-0.4-12.7-10.8-22.8-23.6-22.8c-10.9,0-20.1,7.4-22.8,17.5c-0.5,2-0.8,7.8-0.7,8.5 c-2.3,54.8,39.7,101.7,94.7,105.1C177.7,256.3,183.8,256.1,189.8,255.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.1,109c-4.8,8-15.1,10.6-23.1,5.9c-8-4.8-10.6-15.1-5.9-23.1s15.1-10.6,23.1-5.9l0,0 C99.2,90.6,101.9,101,97.1,109"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOxt);
export default __webpack_public_path__ + "static/media/OXT.7f9bc46bd480e4a642777afa53c366c8.svg";
export { ForwardRef as ReactComponent };